module.exports = __webpack_public_path__ + "media/images/about-us-photo-1309530020f26da8da68c28a20277019.jpg";